module.exports = __webpack_public_path__ + "b5bb7b18e2887511395ca2cf120d0081.pdf";